import * as React from "react";
import { useEffect, useState } from "react";
import { Table } from "../../../../../Shared/Table/Table";
import { DashboardAction } from "../../Action/DashboardAction";
import { NotificationAction } from "../../Action/NotificationAction";
import { DashboardTab, OpreationType } from "../../Resource/Content";
import { DashboardFilterStore, NotificationFilterStore } from "../../Store/Variable";

export const FilterTable = (props) => {
    const [data, setData] = useState(props.data ? props.data.concat() : []);

    useEffect(() => {
        if (data.length == 0 && props.data) {
            setData(props.data.concat());
        }
    }, [props.data]);

    const pressedId =
        props.currentTabIndex == DashboardTab.Workflow
            ? DashboardFilterStore.getPressedId()
            : NotificationFilterStore.getPressedId();

    return (
        <Table
            dragOption={{
                dragable: true,
                onReorder: (d) => {
                    props.onReorder(d);
                },
            }}
            reorderIconTitle="Reorder filter"
            data={data}
            col={[
                {
                    title: "Filter",
                    key: "FilterName",
                    render: (data, row, index) => {
                        return (
                            <a
                                onClick={() => {
                                    props.onClose();
                                    props.currentTabIndex == DashboardTab.Workflow
                                        ? DashboardAction.setPressedId(row.FilterId)
                                        : NotificationAction.setPressedId(row.FilterId);
                                }}
                                className="hyperlink"
                            >
                                {pressedId == row.FilterId ? <b>{data}</b> : data}
                            </a>
                        );
                    },
                },
                {
                    title: "Edit",
                    key: "",
                    render: (data, row, index) => {
                        return (
                            <button
                                className="edit-circle-icon-button label-sr-only"
                                title="Edit filter"
                                onClick={() => props.onEdit(row.FilterId)}
                            >
                                <span className="icon" aria-hidden="true"></span>
                            </button>
                        );
                    },
                },
                {
                    title: "Delete",
                    key: "",
                    render: (data, row, index) => {
                        return (
                            <button
                                className="delete-button"
                                title="Delete filter"
                                disabled={false}
                                onClick={() => props.onChange(OpreationType.Delete, index, row)}
                            >
                                <span className="icon" aria-hidden="true"></span>
                            </button>
                        );
                    },
                },
            ]}
        />
    );
};
